module.exports = __webpack_public_path__ + "static/img/btn.6c0060a.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/commonQifuPop/btn.png
// module id = 322
// module chunks = 32